<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  w: { type: String, default: '' },
  debug:     { type: Boolean, default: false },
  noWrap:    { type: Boolean, default: false },
  tag:       { type: String, default: 'div' },
})

const attrs = useAttrs()
const outerClass = computed(() => attrs.class)
const innerAttrs = computed(() => {
  const { class: _, ...rest } = attrs
  return rest
})
</script>

<template>
  <!-- outer container -->
  <component :is="tag"
             :class="['io-frame', outerClass, { debug }]"
             v-bind="innerAttrs">
    <slot name="pre" />

    <!-- conditional wrap -->
    <template v-if="!noWrap">
      <slot name="w-pre" />
      <Wrap :class="w">
        <slot />
      </Wrap>
      <slot name="w-post" />
    </template>

    <!-- bypass wrap -->
    <template v-else>
      <slot />
    </template>

    <slot name="post" />
  </component>
</template>

<style lang="scss" scoped>
.io-frame {
  > .m-wrap {
    width:100%;
  }

  &.debug {
    >.m-wrap {
      box-shadow: inset 0 0 0 1px blue;
      :deep(.m-col) {
        box-shadow: inset 0 0 0 1px red;
      }
    }
  }
}
</style>
